import {
  ZKSYNC,
  SONIC,
  SUPPORTED_CHAIN_IDS,
  DEFAULT_CHAIN_ID,
  HYPEREVM,
} from './chains'
import { Address } from 'viem'
import { isProd } from './constants'
import { AddressZero } from 'utils/ethersImport'

export const XGMT_EXCLUDED_ACCOUNTS = [
  '0x330eef6b9b1ea6edd620c825c9919dc8b611d5d5',
  '0xd9b1c23411adbb984b1c4be515fafc47a12898b2',
  '0xa633158288520807f91ccc98aa58e0ea43acb400',
  '0xffd0a93b4362052a336a7b22494f1b77018dd34b',
]

const CONTRACTS: Record<number, Record<string, string>> = {
  [HYPEREVM]: {
    Vault: AddressZero,
    Router: '0x14D3AF9c4398A919394ece2BDe13aBefbdA343fD',
    VaultReader: AddressZero,
    Reader: '0x15fCd46BE1500E4bcb2a2c59383F8e6EAc4414eC',
    GlpManager: AddressZero,
    RewardRouter: AddressZero,
    RewardReader: AddressZero,
    GlpRewardRouter: AddressZero,
    NATIVE_TOKEN: AddressZero,
    GLP: AddressZero,
    GMX: AddressZero,
    ES_GMX: AddressZero,
    BN_GMX: AddressZero,
    USDG: AddressZero,
    ES_GMX_IOU: AddressZero,

    StakedGmxTracker: AddressZero,
    BonusGmxTracker: AddressZero,
    FeeGmxTracker: AddressZero,
    StakedGlpTracker: AddressZero,
    FeeGlpTracker: AddressZero,

    StakedGmxDistributor: AddressZero,
    StakedGlpDistributor: AddressZero,

    GmxVester: AddressZero,
    GlpVester: AddressZero,

    OrderBook: AddressZero,
    OrderExecutor: AddressZero,
    OrderBookReader: AddressZero,

    PositionRouter: AddressZero,
    PositionManager: AddressZero,

    TraderJoeGmxAvaxPool: AddressZero,
    ReferralStorage: '0x080ED455C2e49e5F153aE18A745B2282d4a2863D',
    ReferralReader: AddressZero,

    // Synthetics
    DataStore: '0xCB58Ebd9A1221F574665fbbFE86D07237749Ea0A',
    EventEmitter: '0x96eC0685B02FE77b58D8FD82d318B335106C8352',
    ExchangeRouter: '0x90C9e366dA8eF41E9ae7dddE00e3D52b2F7dCDf3',
    SubaccountRouter: '0x58e666E91BEa7891911e4e03143894C8a30C8ac4',
    DepositVault: '0x318224C74C79E6181c2CA4Fe37386B5aE8c99eFa',
    WithdrawalVault: '0x3D2Db105E6A042B9777e7868edA6358FB87D549C',
    OrderVault: '0xF06Cd9d46925a5b4c0954190Bb041ecd969DE011',
    SyntheticsReader: '0x15fCd46BE1500E4bcb2a2c59383F8e6EAc4414eC',
    SyntheticsRouter: '0x14D3AF9c4398A919394ece2BDe13aBefbdA343fD',
    Timelock: '0x24D4254b9649E8714D5F924C52dE0B9aE3c5693e',
    merkelDistributor: '0x9F44ccA98201a156a1A96461be79908eFb5BC945',
    commonPool: '0x024cD51E3F0D2A8214DCcaB7d86EaD8593acB90a',

    Multicall: '0x96C363463aB0Be1a426085F21e469CEcC6A21Cd1',
    PythDataStreamProvider: '0x0C7692E3572bE9daAc98B84765aC1f3c9b1b1593',
  },
}

export const commonPoolContracts: Record<
  number,
  {
    label: string
    value: string
    name: string
    symbol: string
    tokens?: string[]
  }[]
> = {
  [SONIC]: [
    {
      label: 'scUSD',
      value: isProd
        ? '0x0bfFb867472cdaE11D0A10020Ab9a9d9Fdf6193b'
        : '0x8662a6c0821B2b5c6e71cf97B2C66fA7D06d8B75',
      name: 'RFX scUSD Shared Liquidity Vault',
      symbol: 'SLV scUSD',
      tokens: ['USDC'],
    },
    {
      label: 'wS',
      value: isProd
        ? '0x13919E105668792AB630148b03D6b91FF6df0491'
        : '0x0a23345e5f77BC5e985B2acC71481Ba961181b53',
      name: 'RFX wS Shared Liquidity Vault',
      symbol: 'SLV wS',
      tokens: ['S'],
    },
  ],
  [ZKSYNC]: [
    {
      label: 'USN',
      value: isProd
        ? '0x233122C668f6433c0ee5C47A003EEf81c1cc972c'
        : '0xE43824A7Ab9B3920fFe5BbA40E517ccaDdFd97C6',
      name: 'RFX USN Shared Liquidity Vault',
      symbol: 'SLV USN',
    },
  ],
  [HYPEREVM]: [
    {
      label: 'WSTHYPE',
      value: '0x024cD51E3F0D2A8214DCcaB7d86EaD8593acB90a',
      name: 'RFX WSTHYPE Shared Liquidity Vault',
      symbol: 'SLV WSTHYPE',
    },
  ],
}

export const getSwapTokens = (chainId: number, commonPoolAddress: string) => {
  return commonPoolContracts[chainId]?.find(
    (item) => item.value === commonPoolAddress,
  )?.tokens
}

export function getContract(chainId: number, name: string): Address {
  if (!SUPPORTED_CHAIN_IDS.includes(chainId)) {
    return CONTRACTS[DEFAULT_CHAIN_ID][name] as Address
  }
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`)
  }

  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`)
  }

  return CONTRACTS[chainId][name] as Address
}
